





































































































import {
  computed,
  defineComponent,
  ref,
  useContext,
} from '@nuxtjs/composition-api';
import {
  SfButton,
  SfCarousel,
  SfLoader,
  SfProductCard,
  SfSection,
} from '@storefront-ui/vue';

import { useImage, useProduct } from '~/composables';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { useUser } from '~/modules/account/composables/useUser';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import useWishlist from '~/modules/wishlist/composables/useWishlist';

import AddProductItemToCartDialog from './AddProductItemToCartDialog.vue';

export default defineComponent({
  name: 'NewProducts',
  components: {
    SfProductCard,
    SfSection,
    SfLoader,
    SfButton,
    SfCarousel,
    AddProductItemToCartDialog,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    newProducts: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { isAuthenticated } = useUser();
    const { loading, getProductPath } = useProduct();
    const { isInWishlist, addOrRemoveItem } = useWishlist();
    const {
      loading: isCartLoading,
      addItemToCart,
      isInCart,
      error,
    } = useAddToCart();

    const currentClick = ref(null);
    const { app } = useContext();

    const isOpen = ref<Boolean>(false);
    const { isDesktop } = app.$device;

    const nowProduct = ref(null);

    const mappedProducts = computed(() =>
      props.newProducts.map((product: any) => ({
        ...product,
        isInWishlist: isInWishlist({ product }),
      }))
    );

    const addItemToWishlist = async (product) => {
      await addOrRemoveItem({ product });
    };

    const { getMagentoImage, imageSizes } = useImage();

    const handleAddItemToCart = async (product, i) => {
      currentClick.value = i;
      await addItemToCart({
        product,
        quantity: 1,
      });

      if (isInCart(product) && !error.value?.addItem?.message) {
        isOpen.value = true;
        nowProduct.value = product;
      }
      currentClick.value = null;
    };
    const closedialog = () => {
      isOpen.value = false;
    };

    return {
      isCartLoading,
      addItemToCart,
      addItemToWishlist,
      isAuthenticated,
      isInCart,
      isInWishlist,
      loading,
      mappedProducts,
      productGetters,
      getMagentoImage,
      imageSizes,
      getProductPath,
      currentClick,
      handleAddItemToCart,
      nowProduct,
      closedialog,
      isOpen,
    };
  },
});
